import { Card } from 'pages/Toolbox/StandardParts/components/ui/card'
import { Badge } from 'pages/Toolbox/StandardParts/components/ui/badge'
import { ElectronicsPartsInformation } from 'store/types'
import { ReactComponent as ElectronicsIcon } from 'assets/icons/014-chip.svg'

export const EmissionHeader = ({
  general,
  technical,
  identification,
}: ElectronicsPartsInformation) => {
  const title = identification.fullName || identification.sid
  const weightLabel =
    technical.weight != null
      ? `${technical.weight}${technical.weightUnit ? ` ${technical.weightUnit}` : ''}`
      : '—'

  return (
    <Card className="p-6">
      <div className="flex flex-col md:flex-row gap-6">
        <div className="flex-shrink-0 w-48 h-48 bg-muted rounded-lg flex items-center justify-center">
          <ElectronicsIcon className="w-24 h-24 text-primary-600" />
        </div>
        <div className="flex-1 space-y-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              {general.manufacturer ? (
                <Badge variant="secondary">{general.manufacturer}</Badge>
              ) : null}
              {identification.class ? (
                <Badge variant="outline">{identification.class}</Badge>
              ) : null}
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2">{title}</h1>
            <p className="text-muted-foreground">
              {general.description || identification.fullName}
            </p>
          </div>
          <div className="flex flex-wrap gap-4 text-sm">
            {general.mpn ? (
              <div>
                <span className="text-muted-foreground">MPN:</span>
                <span className="ml-2 font-medium">{general.mpn}</span>
              </div>
            ) : null}
            <div>
              <span className="text-muted-foreground">SID:</span>
              <span className="ml-2 font-medium">
                {identification.sid || identification.sustamizeId}
              </span>
            </div>
            <div>
              <span className="text-muted-foreground">Weight:</span>
              <span className="ml-2 font-medium">{weightLabel}</span>
            </div>
          </div>
          <p className="text-muted-foreground">
            Reference unit: {general.functionalUnit || '1 kg finished product'}
          </p>
          {technical.materialCompositionSource ? (
            <p className="text-sm text-muted-foreground break-all">
              <span className="font-medium">Material source: </span>
              <a
                href={technical.materialCompositionSource}
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                {technical.materialCompositionSource}
              </a>
            </p>
          ) : null}
        </div>
      </div>
    </Card>
  )
}
